
import { ref, defineComponent, onMounted, computed } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import _ from "lodash";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import ExportCustomerModal from "@/components/modals/forms/ExportCustomerModal.vue";
import AddCustomerModal from "@/components/modals/forms/AddCustomerModal.vue";
import { Actions } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import * as Yup from "yup";

interface Buscador {
  estado?: number;
  factura?: number;
  empresaId?: number;
  fechaInicio?: Date;
  fechaTermino?: Date;
  proveedorId: number;
}

export default defineComponent({
  name: "kt-customer-list",
  components: {
    DataTable,
    Column,
    ExportCustomerModal,
    AddCustomerModal,
  },
  data() {
    return {
      store: useStore(),
      router: useRouter(),
    };
  },
  methods: {
    formatDate(value) {
      value = new Date(value);
      return value.toLocaleDateString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
    formatCurrency(value) {
      return value.toLocaleString("es-CL", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        style: "currency",
        currency: "CLP",
      });
    },
  },
  setup() {
    const submitButton1 = ref<HTMLElement | null>(null);
    const store = useStore();
    const router = useRouter();
    const ticketActual = ref(null);
    onMounted(() => {
      setCurrentPageBreadcrumbs("Tickets", ["Página", "Dashboard"]);
      buscarTickets();
    });
    const buscador = ref<Buscador>({
      proveedorId: store.getters.currentUser.id,
    });
    const buscadorValidator = Yup.object().shape({});
    const editTicket = (ticket) => {
      router.push({
        name: "apps-tickets-details",
        params: { id: ticket.ticketId },
      });
    };
    const verTicket = (data) => {
      ticketActual.value = data;
      display.value = true;
    };
    const buscarTickets = () => {
      store
        .dispatch(Actions.GET_TICKETES)
        .then(() => {
          loading.value = false;
        })
        .catch(() => {
          const [error] = Object.keys(store.getters.getTicketErrors);
        });
    };
    const currentUser = computed(() => {
      return store.getters.currentUser;
    });
    const display = ref(false);
    const filters1 = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const search = ref(null);
    const selectedTickets = ref(null);
    const loading = ref(true);
    return {
      filters1,
      buscador,
      selectedTickets,
      loading,
      buscadorValidator,
      buscarTickets,
      submitButton1,
      editTicket,
      verTicket,
      ticketActual,
      display,
    };
  },
});
